'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ramda = require('ramda');

var _immutable = require('../immutable');

var _delegations = require('./model_concerns/delegations');

var _delegations2 = _interopRequireDefault(_delegations);

var _serialization = require('./model_concerns/serialization');

var _is_model = require('./model_concerns/is_model');

var _child_models = require('./model_concerns/child_models');

var _validations = require('./model_concerns/validations');

var _parent_pointer = require('./model_concerns/parent_pointer');

var _context = require('./model_concerns/context');

var _internal_instance = require('./model_concerns/internal_instance');

var _freeze_props = require('./model_concerns/freeze_props');

var _freeze_props2 = _interopRequireDefault(_freeze_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_DISPLAY_NAME = '<<anonymous Model>>';

function callOrIdentity(valueToCall) {
  return (0, _ramda.ifElse)((0, _ramda.is)(Function), function (f) {
    return f(valueToCall);
  }, _ramda.identity);
}

function getValue(attr, key) {
  if ((0, _ramda.isNil)(attr)) {
    return attr;
  } else if ((0, _immutable.isImmutableType)(attr) || (0, _is_model.isModel)(attr)) {
    return attr.get(key);
  } else {
    return attr[key];
  }
}

function setValue(attr, key, value) {
  if ((0, _immutable.isImmutableType)(attr) || (0, _is_model.isModel)(attr)) {
    return attr.set(key, value);
  } else if ((0, _ramda.is)(Array, attr)) {
    return (0, _ramda.over)((0, _ramda.lensIndex)(key), (0, _ramda.always)(value), attr);
  } else {
    return (0, _ramda.set)((0, _ramda.lensProp)(key), value, attr);
  }
}

function getPropKeys(model) {
  return (0, _ramda.keys)(model.constructor.defaultProps);
}

function evaluateProps(currentProps, props) {
  return (0, _ramda.reduce)(function (memo, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return (0, _ramda.merge)(memo, _defineProperty({}, key, callOrIdentity(currentProps[key])(value)));
  }, {}, (0, _ramda.toPairs)(props));
}

function getSendUpdateType(model) {
  var actionTypes = model.constructor.actionTypes;


  if (actionTypes && actionTypes.UPDATE) {
    return actionTypes.UPDATE;
  } else {
    return (0, _ramda.toUpper)(model.displayName) + '_UPDATE';
  }
}

function getDefaultProps(model) {
  return (0, _ramda.map)(callOrIdentity(undefined), model.constructor.defaultProps);
}

function initProps(model, props) {
  var propKeys = getPropKeys(model);

  return (0, _ramda.merge)(getDefaultProps(model), (0, _ramda.pick)(propKeys, props));
}

function runValidations(model, props) {
  var _model$constructor = model.constructor,
      propTypes = _model$constructor.propTypes,
      defaultProps = _model$constructor.defaultProps;

  var contextName = 'model ' + model.displayName;

  (0, _validations.checkKeys)(defaultProps, props, contextName, 'defaultProps');

  // make prop type checks optional now
  if (!(0, _ramda.isEmpty)(propTypes)) {
    (0, _validations.ensureValidators)(propTypes, defaultProps, contextName, 'propTypes', 'defaultProps');

    (0, _validations.checkValues)(propTypes, props, contextName, 'prop');
  }
}

var Model = function () {
  function Model() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$internalInstanc = _ref3.internalInstance,
        internalInstance = _ref3$internalInstanc === undefined ? undefined : _ref3$internalInstanc;

    _classCallCheck(this, Model);

    (0, _is_model.markModel)(this);

    this.__props__ = initProps(this, props);
    if (process.env !== 'production') {
      runValidations(this, this.props());
      (0, _freeze_props2.default)(this.props());
    }

    (0, _delegations2.default)(this, this.constructor.delegates);
    (0, _internal_instance.setInternalInstance)(this, internalInstance);

    // override methods with the version from internal instance
    // to keep pointer stable
    (0, _internal_instance.inheritMethodsFromInternalInstance)(this);

    // only set parent pointer when child model doesn't have children
    // force flush will happen at reducer
    (0, _parent_pointer.ensureParentPointerOnChildModels)(this, false);
  }

  _createClass(Model, [{
    key: 'get',
    value: function get(key) {
      return this.__props__[key];
    }
  }, {
    key: 'props',
    value: function props() {
      return this.__props__;
    }

    // alias for props

  }, {
    key: 'attributes',
    value: function attributes() {
      return this.__props__;
    }
  }, {
    key: 'childModels',
    value: function childModels() {
      return (0, _child_models.extractChildModels)(this);
    }
  }, {
    key: 'childModelsRecursive',
    value: function childModelsRecursive() {
      return (0, _child_models.extractChildModelsRecursively)(this);
    }
  }, {
    key: 'setMulti',
    value: function setMulti(props) {
      var currentProps = this.props();
      var evaluatedProps = evaluateProps(currentProps, props);

      if (process.env !== 'production') {
        runValidations(this, evaluatedProps);
      }

      // all the same, return self
      if ((0, _ramda.all)(function (key) {
        return currentProps[key] === evaluatedProps[key];
      }, (0, _ramda.keys)(evaluatedProps))) {
        return this;
      }

      return new this.constructor((0, _ramda.merge)(currentProps, evaluatedProps), {
        internalInstance: this.__internalInstance__
      });
    }
  }, {
    key: 'set',
    value: function set(name, value) {
      return this.setMulti(_defineProperty({}, name, value));
    }

    // alias for set

  }, {
    key: 'mutate',
    value: function mutate(name, value) {
      return this.set(name, value);
    }
  }, {
    key: 'getIn',
    value: function getIn(path) {
      return (0, _ramda.reduce)(getValue, this, path);
    }
  }, {
    key: 'updateIn',
    value: function updateIn(path, valueOrMapper) {
      var nodesInRow = (0, _ramda.reduce)(function (memo, key) {
        var nextItem = getValue((0, _ramda.last)(memo), key);

        if (nextItem) {
          return (0, _ramda.append)(nextItem, memo);
        } else {
          throw new Error('Cannot find item in given path');
        }
      }, [this], path);

      var oldValue = (0, _ramda.last)(nodesInRow);
      var newValue = callOrIdentity(oldValue)(valueOrMapper);

      if (oldValue === newValue) {
        return this;
      } else {
        return (0, _ramda.reduceRight)(function (_ref4, value) {
          var _ref5 = _slicedToArray(_ref4, 2),
              parent = _ref5[0],
              key = _ref5[1];

          return setValue(parent, key, value);
        }, newValue, (0, _ramda.zip)((0, _ramda.take)(path.length, nodesInRow), path));
      }
    }
  }, {
    key: 'clear',
    value: function clear() {
      return this.setMulti(getDefaultProps(this));
    }
  }, {
    key: 'getContext',
    value: function getContext(key) {
      return (0, _context.getContext)(this, key);
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {};
    }
  }, {
    key: 'getService',
    value: function getService(name) {
      return this.__internalInstance__.getService(name);
    }
  }, {
    key: 'getServices',
    value: function getServices() {
      return this.__internalInstance__.getServices();
    }

    // framework level support for dispatch
    // treating it differently make it significantly easier
    // for developers because then we hide the concept of path

  }, {
    key: 'dispatch',
    value: function dispatch(action) {
      var dispatch = (0, _context.getContextFromAncestors)(this, 'dispatch');

      dispatch(_extends({}, (0, _ramda.when)((0, _ramda.is)(String), function (type) {
        return { type: type };
      })(action), {
        path: (0, _parent_pointer.getPathFromRoot)(this)
      }));
    }

    // whether two models are both decendants
    // of the same initial model

  }, {
    key: 'isPeer',
    value: function isPeer(model) {
      return this.__internalInstance__ === model.__internalInstance__;
    }
  }, {
    key: 'toJS',
    value: function toJS() {
      return (0, _serialization.toJS)(this);
    }
  }, {
    key: 'toJSON',
    value: function toJSON() {
      return _extends({}, (0, _serialization.toJSON)(this), {
        path: (0, _parent_pointer.getPathFromRoot)(this)
      });
    }
  }, {
    key: 'sendUpdate',
    value: function sendUpdate(name, value) {
      this.dispatch({
        type: getSendUpdateType(this),
        payload: {
          name: name,
          value: value
        }
      });
    }
  }, {
    key: 'recvUpdate',
    value: function recvUpdate() {
      return {
        type: getSendUpdateType(this),
        update: function update(model, action) {
          var _action$payload = action.payload,
              name = _action$payload.name,
              value = _action$payload.value;


          return [model.set(name, value)];
        }
      };
    }
  }, {
    key: 'displayName',
    get: function get() {
      if (this.constructor.displayName === DEFAULT_DISPLAY_NAME) {
        return this.constructor.name;
      } else {
        return this.constructor.displayName;
      }
    }
  }]);

  return Model;
}();

Model.actionTypes = {};
Model.propTypes = {};
Model.defaultProps = {};
Model.contextTypes = {};
Model.childContextTypes = {};
Model.services = {};
Model.delegates = {};
Model.displayName = DEFAULT_DISPLAY_NAME;

exports.default = Model;